import { useMediaQuery, Zoom } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import Grid from '@mui/material/Grid2'
import { FC, PropsWithChildren } from 'react'
import { theme } from '../../theme'
import { BlockWrapper } from './BlockWrapper'

export const RightSidebarWrapper: FC<PropsWithChildren> = ({ children }) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    return (
        <>
            {isMobile ? (
                <Dialog
                    maxWidth="md"
                    fullWidth={true}
                    sx={{
                        overflow: 'hidden',
                        borderRadius: '0 !important',

                        '.MuiDialog-container>.MuiPaper-root': {
                            m: 0,
                            borderRadius: 0,
                            width: '100%',
                            height: '100%',
                            maxHeight: 'unset',
                        },
                    }}
                    open>
                    {children}
                </Dialog>
            ) : (
                <Zoom in>
                    <Grid sx={{ width: '360px' }}>
                        <BlockWrapper>
                            <Grid
                                sx={{
                                    height: '100%',
                                }}>
                                {children}
                            </Grid>
                        </BlockWrapper>
                    </Grid>
                </Zoom>
            )}
        </>
    )
}
